<header>
  <section class="sub-header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-3 bor">
          <div class="phone">
            <a href="tel:+22921602843">
              <img src="assets/img/phone.svg">
              <p style="margin-bottom: 0px">(+229) 21 60 28 43 - 96 35 77 22</p>
            </a>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 bor">
          <div class="mail">
            <a href="mailto:info@talentsplusafrique.com?subject=Mail de notre site Web ">
              <img src="assets/img/mail.svg">
              <p style="margin-bottom: 0px">info@talentsplusafrique.com</p>
            </a>
          </div>
        </div>
        <div class="col-12 col-sm-3 col-lg-2 bor">
          <div class="social">
            <a target="_blank" href="https://www.facebook.com/talentsplusafrique"><img
                src="assets/img/facebook.svg"></a>
            <a target="_blank" href="https://www.linkedin.com/in/talents-plus-groupe-b325887a/"><img
                src="assets/img/linkedin.svg"></a>
            <a target="_blank" href="https://twitter.com/TalentsPlus"><img src="assets/img/twitter.svg"></a>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-lg-4 bor">
          <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitForm()">
            <div class="input-group" style="    margin-bottom: -15px;">
              <input class="form-control"
                style="    border-radius: 15px 0px 0px 15px !important; height: 28px !important;"
                formControlName="email" placeholder="Entrer votre email" onfocus="this.placeholder = ''"
                onblur="this.placeholder = 'Entrer votre email '" type="email">
              <div class="input-group-prepend">
                <button type="submit" style=" height: 35px;" class="btn btn-submit">Souscrire</button>
              </div>
              <p class="text-danger" *ngIf="isLoading">Veuillez patienter...</p>
            </div>
          </form>
          <!-- <div class="connect">
            <a class="log"
              routerLink="connexion">Connexion</a>
            <a class="sign"
              routerLink="/inscription">Inscription</a>
          </div> -->

        </div>
      </div>
    </div>
  </section>
  <section class="top-header">
    <div class="container pad" style="">
      <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand pb-2" href="/"><img class="logo" src="assets/img/logo.png"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav ">
            <li class="nav-item ">
              <a class="nav-link" href="/">Accueil<span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" routerLink="/a-propos/talents-plus-afrique">A propos </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item" href="/a-propos/talents-plus-afrique">Talents Plus Afrique</a></li>
                <li><a class="dropdown-item" href="/visions-valeurs">Visions et Valeurs</a></li>
                <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle">Les filiales</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="/filiales/talents-plus-conseils-benin">Talents Plus Conseils
                        Bénin</a>
                    </li>
                    <li><a class="dropdown-item" href="/filiales/talents-plus-ett-benin">Talents Plus E.T.T Bénin</a>
                    </li>
                    <li><a class="dropdown-item" href="/filiales/talents-plus-conseils-cote-divoire">Talents Plus
                        Conseils Côte
                        d’ivoire</a>
                    </li>
                    <li><a class="dropdown-item" href="/filiales/talents-plus-conseils-mali">Talents Plus Conseils
                        Mali</a>
                    </li>
                    <li><a class="dropdown-item" href="/filiales/talents-plus-ett-togo">Talents Plus E.T.T Togo</a>
                    </li>
                    <li><a class="dropdown-item" href="/filiales/gisea-sarl">GISEA SARL</a>
                    </li>
                  </ul>
                </li>
                <li><a class="dropdown-item" href="/a-propos/talents-plus-afrique#distinc">Nos distinctions</a></li>
                <li><a class="dropdown-item" href="/a-propos/talents-plus-afrique#partenaires">Nos partenaires</a></li>
                <li><a class="dropdown-item" href="/a-propos/talents-plus-afrique#client">Nos Secteurs</a></li>
                <li><a class="dropdown-item" href="/conseils">Nos Articles</a></li>
                <!-- <li><a class="dropdown-item" href="/contact/carte">Pays où nous sommes intervenu</a></li> -->
              </ul>
            </li>
            <li class="nav-item ">
              <a class="nav-link" href="/nos-equipes">Nos équipes<span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">Nos produits</a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li class="dropdown-submenu"><a href="/nos-produits/travail-temporaire"
                    class="dropdown-item dropdown-toggle">Travail
                    temporaire/portage</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Externalisation</a></li>
                    <li><a class="dropdown-item">Mise à disposition de personnel</a></li>
                    <li><a class="dropdown-item">Portage</a></li>
                    <li><a class="dropdown-item">Mise à disposition de personnel de maison</a></li>
                  </ul>
                </li>

                <li class="dropdown-submenu"><a href="/nos-produits/recrutement"
                    class="dropdown-item dropdown-toggle">Recrutement</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Recrutement complet</a></li>
                    <li><a class="dropdown-item">Assistance technique</a></li>
                    <li><a class="dropdown-item">Mise à disposition de CV </a></li>
                    <li><a class="dropdown-item">Décryptage de personalité</a></li>
                    <li><a class="dropdown-item">Chasse de tête</a></li>
                    <li><a class="dropdown-item"> CVthèque </a></li>
                    <li><a class="dropdown-item"> Coaching de préparation </a></li>
                    <li><a class="dropdown-item"> E-recrutment </a></li>
                  </ul>
                </li>

                <li class="dropdown-submenu"><a href="/nos-produits/formation"
                    class="dropdown-item dropdown-toggle">Formation</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Intra-entreprise</a></li>
                    <li><a class="dropdown-item">Inter-entreprises</a></li>
                    <li><a class="dropdown-item">Individuelle</a></li>
                    <li><a class="dropdown-item">Coaching</a></li>
                    <li><a target="_blank" href="assets/docs/Catalogue_de_formation.pdf" class="dropdown-item">Catalogue
                        de formation</a></li>
                    <li><a target="_blank" href="assets/docs/Calendrier 2eme trimestre 2023.pdf"
                        class="dropdown-item">Calendrier
                      </a></li>
                    <li><a href="https://www.talentsplusclass.com" target="_blank" class="dropdown-item">E-learning</a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu"><a href="/nos-produits/conseil-pme-pmi"
                    class="dropdown-item dropdown-toggle">Conseils PME/PMI</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Elaboration de plan d'affaire</a></li>
                    <li><a class="dropdown-item">Note d'information bancaire</a></li>
                    <li><a class="dropdown-item">Recherche de financement</a></li>
                    <li><a class="dropdown-item">Coaching</a></li>
                    <li><a class="dropdown-item">Réalisation de diagnostic</a></li>
                    <li><a class="dropdown-item">Renforcement de capacités</a></li>

                  </ul>
                </li>
                <li class="dropdown-submenu"><a href="/nos-produits/assistance-rh"
                    class="dropdown-item dropdown-toggle">Assistance RH / Droit Social</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Gestion de la Paie</a></li>
                    <li><a class="dropdown-item">Gestion Externalisée des Ressources Humaines.</a></li>
                    <li><a class="dropdown-item">Conseils en Droit Social</a></li>

                  </ul>
                </li>

                <li class="dropdown-submenu"><a href="/nos-produits/etudes-rh"
                    class="dropdown-item dropdown-toggle">Etudes RH/Générales</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Audit organisationnel</a></li>
                    <li><a class="dropdown-item">Bilan des compétences
                      </a></li>
                    <li><a class="dropdown-item">Audit social
                      </a></li>
                    <li><a class="dropdown-item">Audit des outils et Politiques RH

                      </a></li>
                    <li><a class="dropdown-item">Enquête de satisfaction

                      </a></li>
                    <li><a class="dropdown-item">Enquête d’engagement</a></li>
                    <li><a class="dropdown-item">Enquête salariale</a></li>
                    <li><a class="dropdown-item">Culture d'entreprise</a></li>
                    <li><a class="dropdown-item">Système et évaluation des performances</a></li>
                  </ul>
                </li>
                <li class="dropdown-submenu"><a href="/nos-produits/sirh" class="dropdown-item dropdown-toggle">SIRH</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Talents Gest Paie V1</a></li>
                    <li><a class="dropdown-item">Talents Gest Paie V2</a></li>
                    <li><a class="dropdown-item">Simulation de salaire Net</a></li>
                  </ul>
                </li>
                <li class="dropdown-submenu"><a href="/nos-produits/etudes-rh" class="dropdown-item ">RSE</a>
                <li class="dropdown-submenu"><a href="/nos-produits/etudes-rh" class="dropdown-item ">Staffing</a>

                </li>
              </ul>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" href="job-list">Offre d'emploi</a>
            </li> -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" href="">Nos offres</a>

              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item" href="job-list">Offres d'emplois</a></li>
                <li class="dropdown-submenu"><a class="dropdown-item dropdown-toggle"
                    href="formation/offre-de-formation">Offres
                    de formations</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Intra-entreprise</a></li>
                    <li><a class="dropdown-item">Inter-entreprises</a></li>
                    <li><a class="dropdown-item">Individuelle</a></li>
                    <li><a class="dropdown-item">Coaching</a></li>
                    <li><a target="_blank" href="assets/docs/Catalogue_de_formation.pdf" class="dropdown-item">Catalogue
                        de formation</a></li>
                    <li><a target="_blank" href="assets/docs/Calendrier 2eme trimestre 2023.pdf"
                        class="dropdown-item">Calendrier
                      </a></li>
                    <li><a href="https://www.talentsplusclass.com" target="_blank" class="dropdown-item">E-learning</a>
                  </ul>
                </li>
                <li><a class="dropdown-item" href="#">Intérim</a></li>
                <li><a class="dropdown-item" href="#">PME/PMI</a></li>

              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">CV Thèque</a>

              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item" routerLink="/depot-cv">Dépôt de CV</a></li>
                <li><a class="dropdown-item" href="cv/modele-cv-consultant">Modèle de CV consultant</a></li>
                <li><a class="dropdown-item" href="cv/modele-cv-emploi">Modèle de CV emploi</a></li>

                <li class="dropdown-submenu"><a href="/conseils" class="dropdown-item dropdown-toggle">Conseils en
                    Insertion</a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item">Orientation des jeunes</a></li>
                    <li><a class="dropdown-item">Préparer son insertion professionnelle </a></li>
                    <li><a class="dropdown-item">Comment rédiger un CV professionnel </a></li>
                  </ul>
                </li>

              </ul>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" href="">Contactez-nous</a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item" href="/contact/benin-tpc">TPC Bénin</a></li>
                <li><a class="dropdown-item" href="/contact/benin-ett">TP ETT Bénin</a></li>
                <li><a class="dropdown-item" href="/contact/cote-d-ivoire">TPC CI</a></li>
                <li><a class="dropdown-item" href="/contact/mali">TPC Mali</a></li>
                <li><a class="dropdown-item" href="/contact/togo">TP ETT Togo</a></li>
                <li><a class="dropdown-item" href="/contact/gisea-sarl">GISEA Sarl</a></li>

              </ul>
            </li>
            <li class="nav-item  login-desk" *ngIf="!userIsConnected">
              <a class="nav-link btn log " routerLink="connexion">Connexion</a>
            </li>
            <li class="nav-item login-desk" *ngIf="!userIsConnected">
              <a class="nav-link btn sign" routerLink="/inscription">Inscription</a>
            </li>
            <li class="nav-item dropdown" *ngIf="userType != 'admin' && userIsConnected ">
              <a class="nav-link dropdown-toggle" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" href=""><img src="assets/img/avatar.png" width="55" alt=""></a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item">{{ functionsService.wordWrap(userName, 20) }}</a></li>
                <!-- candidat -->
                <li *ngIf="(userType == 'candidat')"><a class="dropdown-item" routerLink="/accueil/candidat">Tableau de
                    bord</a></li>
                <li *ngIf="(userType == 'candidat')"><a class="dropdown-item" routerLink="/candidat-infos">CVthèques</a>
                </li>
                <li *ngIf="(userType == 'candidat')"><a class="dropdown-item" routerLink="job-list">Offres d'emploi</a>
                </li>
                <!-- <li *ngIf="(userType == 'candidat')"><a class="dropdown-item" routerLink="/mes-sauvegardes">Alerte et
                    sauvegardes</a></li> -->
                <!-- consultant -->
                <li *ngIf="(userType=='consultant')"><a class="dropdown-item" routerLink="/accueil/consultant">Tableau
                    de bord</a></li>
                <li *ngIf="(userType=='consultant')"><a class="dropdown-item"
                    routerLink="/compte-consultant">CVthèques</a></li>
                <!-- Entreprise -->
                <li *ngIf="(userType == 'entreprise')"><a class="dropdown-item" routerLink="/accueil/entreprise">Tableau
                    de bord</a></li>
                <li *ngIf="(userType == 'entreprise')"><a class="dropdown-item" routerLink="/tous-les-candidats">Liste
                    CVthèques</a></li>
                <li *ngIf="(userType == 'entreprise')"><a class="dropdown-item"
                    routerLink="/publier-offre-emploi">Poster avis</a></li>
                <li *ngIf="(userType == 'entreprise')"><a class="dropdown-item" routerLink="#">Requête</a></li>
                <li><a class="dropdown-item" routerLink="/changer-mot-de-passe/{{ userType }}">Changer mot de passe</a>
                </li>
                <li><a class="dropdown-item" href="#" (click)="logout()">Se déconnecter</a></li>

                <!-- <li *ngIf="(userType == 'candidat')"
                  class="dropdown-submenu"><a class="dropdown-item dropdown-toggle">Candidat</a>

                  <ul class="dropdown-menu">
                    <ul>
                      <li><a class="dropdown-item"
                          routerLink="/accueil/candidat">Tableau de bord</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/compte-candidat">CVthèques</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/">Offres d'emploi</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/mes-sauvegardes">Alerte et sauvegardes</a></li>
                    </ul>
                  </ul>
                </li> -->
                <!--
                <li *ngIf="(userType=='consultant')"
                  class="dropdown-submenu"><a class="dropdown-item dropdown-toggle">Consultant</a>

                  <ul class="dropdown-menu">
                    <ul>
                      <li><a class="dropdown-item"
                          routerLink="/accueil/consultant">Tableau de bord</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/compte-consultant">CVthèques</a></li>
                    </ul>
                  </ul>
                </li> -->
                <!-- <li *ngIf="(userType == 'entreprise')"
                  class="dropdown-submenu"><a class="dropdown-item dropdown-toggle">Entreprise</a>

                  <ul class="dropdown-menu">
                    <ul>
                      <li><a class="dropdown-item"
                          routerLink="/accueil/entreprise">Tableau de bord</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/tous-les-candidats">Liste CVthèques</a></li>
                      <li><a class="dropdown-item"
                          routerLink="/publier-offre-emploi">Poster avis</a></li>
                      <li><a class="dropdown-item"
                          routerLink="#">Requête</a></li>
                    </ul>
                  </ul>
                </li> -->

              </ul>
            </li>
            <!-- <li *ngIf="userType == 'admin'" class="nav-item">
              <a routerLink="admin" class="nav-link">Accueil Admin</a>
            </li> -->
            <li class="nav-item dropdown" *ngIf="userType == 'admin'">
              <a class="nav-link dropdown-toggle" id="" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" href=""><img src="assets/img/avatar.png" width="55" alt=""></a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item">{{ functionsService.wordWrap(userName, 20) }}</a></li>
                <!-- candidat -->


                <a routerLink="admin" class="dropdown-item">Accueil Admin</a>
                <li><a class="dropdown-item" routerLink="/changer-mot-de-passe/{{ userType }}">Changer mot de passe</a>
                </li>
                <li><a class="dropdown-item" href="#" (click)="logout()">Se déconnecter</a></li>
              </ul>
            </li>
            <!-- <li *ngIf="userIsConnected"
              class="nav-item dropdown"><a href=""
                class="nav-link dropdown-toggle"
                id=""
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">{{ functionsService.wordWrap(userName, 20) }}</a>
              <ul class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink">
                <li><a class="dropdown-item"
                    routerLink="/changer-mot-de-passe/{{ userType }}">Changer mot de passe</a></li>
                <li><a class="dropdown-item"
                    href="#"
                    (click)="logout()">Se déconnecter</a></li>
              </ul>
            </li> -->
            <!-- <li class="nav-item">
              <a class="nav-link"
                onclick="doGTranslate('fr|fr')"
                style="display: inline-block; padding-right: 0px;"
                href="#">FR |</a>
              <a class="nav-link"
                translate="no"
                onclick="doGTranslate('fr|en') "
                style="display: inline-block; padding-left: 0px;"
                href="#">EN <img src="assets/img/globe.svg"></a>
            </li> -->


            <li>
              <div class="connect-two">
                <a class="log-two" routerLink="/connexion">Connexion</a>
                <a class="sign" routerLink="/inscription">Inscription</a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>

  </section>

</header>